import { createAction, createSlice } from "@reduxjs/toolkit";

const addOrderSlice = createSlice({
  name: "addOrder",
  initialState: { data: null, processing: false },
  reducers: {
    pending(state) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      state.processing = false;
      state.data = action.payload.data;
      /* TODO: reducer for success*/
    },
    failure(state) {
      state.processing = false;
      /* TODO: reducer for failure*/
    },
  },
});

const { name, actions, reducer } = addOrderSlice;
const addOrderAction = createAction(name);

export {
  addOrderAction,
  actions as addOrderActions,
  reducer as addOrderReducer,
};
